import { useEffect, useState } from "react"
import { useLocation, useHistory } from "react-router-dom"
import { useParams } from "react-router-dom"
import UpdateUserForm from "../components/UpdateUserForm"
import CustomButton from "../../../v2-components/Antd/Button"

const UserDetailPage = () => {
    const { email } = useParams()
    const location = useLocation()
    const history = useHistory()
    const [userData, setUserData] = useState(null)

    useEffect(() => {
        if (location.state && location.state.userData) {
            setUserData(location.state.userData)
        }
    }, [location])

    const handleCancel = () => {
        history.push("/v2/user-management?tab=2")
    }

    return (
        <div className="container">
            <h2 className="page-title">{email}</h2>
            <CustomButton className="no-padding-button" type="link" onClick={handleCancel}>
                Volver a usuarios
            </CustomButton>
            {userData ? <UpdateUserForm values={userData} /> : <div>Cargando...</div>}
        </div>
    )
}

export default UserDetailPage